export const appConstants = {
  userManagement: {
    defaultAdminUserName: "admin",
  },
  localization: {
    defaultLocalizationSourceName: "RasporediMe",
  },
  authorization: {
    encrptedAuthTokenName: "enc_auth_token",
    impersonateTokenName: "RasporediMe-ImpersonateToken",
  },
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL,
  remoteServiceBaseUrl: import.meta.env.VITE_REMOTE_SERVICE_BASE_URL,

  remoteServiceApiKey: import.meta.env.VITE_REMOTE_SERVICE_API_KEY,

  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY,

  firebaseConfig: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  },
  vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,

  cloudinaryBaseUrl: import.meta.env.VITE_CLOUDINARY_BASE_URL,

  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || "",
  facebookAppId: import.meta.env.VITE_FACEBOOK_APP_ID || "",

  // Empty turns tracking and the cookie banner off (local dev, preview deploys)
  gtmId: import.meta.env.VITE_GTM_ID || "",
};
